import { render, staticRenderFns } from "./NavigationDrawerContainer.vue?vue&type=template&id=0dbdd86e&"
import script from "./NavigationDrawerContainer.vue?vue&type=script&lang=js&"
export * from "./NavigationDrawerContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dbdd86e')) {
      api.createRecord('0dbdd86e', component.options)
    } else {
      api.reload('0dbdd86e', component.options)
    }
    module.hot.accept("./NavigationDrawerContainer.vue?vue&type=template&id=0dbdd86e&", function () {
      api.rerender('0dbdd86e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/app/NavigationDrawerContainer.vue"
export default component.exports